import { createContext, useContext } from 'react';

/// Como o Estoque fala de unidade (ADR 0039). A composição fornece; o módulo só lê.
export interface InventoryUnits {
  /// A empresa tem mais de uma unidade: cada local diz de qual unidade é.
  showUnits: boolean;
  options?: Array<{ value: string; label: string }> | undefined;
  activeBusinessUnitId?: string | null | undefined;
  /// Visão consolidada: lê as unidades alcançadas somadas, e nada se movimenta.
  consolidated: boolean;
}

const context = createContext<InventoryUnits>({ showUnits: false, consolidated: false });

export const InventoryUnitsProvider = context.Provider;

export function useInventoryUnits(): InventoryUnits {
  return useContext(context);
}

/// "Prateleira · Depósito" quando a empresa tem várias unidades; só "Prateleira" quando tem uma.
export function locationLabel(
  location: { displayName: string; businessUnit?: { displayName: string } | undefined },
  showUnits: boolean,
): string {
  return showUnits && location.businessUnit
    ? `${location.displayName} · ${location.businessUnit.displayName}`
    : location.displayName;
}
